<template>
  <div class="wrapper">
    <div>
      <CButton  variant="outline" color="info" @click="largeModal = true">Add New Announcment</CButton>
      <CRow class="mt-3">
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Untuk saat ini, announcement hanya kelihatan di MyIFGF Portal"
        />
      </CCol>
    </CRow>
    </div> 
    
    <CModal
      title="Create New Announcment"
      color="info"
      :show.sync="largeModal"
    >
     <CInput
              label="Subject"
              placeholder="Create A Subject"
              
            />
            <c-textarea
              label="Announcment"
              placeholder="Write your announcment"
              rows="5"
            />
            <label> Recipient </label>
            <div class="row">
            <div class="col-7">
            <c-input-checkbox
              label="Admin Office"
              
            />
              <c-input-checkbox
              label="Dept Core Team"
              
            />
              <c-input-checkbox
              label="Head of Department"
              
            />
              <c-input-checkbox
              label="iCare Coach"
              
            />
              <c-input-checkbox
              label="iCare Core Team"
              
            />
              <c-input-checkbox
              label="iCare Leader"
              
            />
            </div>
            <div class="col-5">
              <c-input-checkbox
              label="iKids"
              
            />
              <c-input-checkbox
              label="iKids Teacher"
              
            />
             <c-input-checkbox
              label="Member"
              
            />
             <c-input-checkbox
              label="Super Admin"
              
            />
             <c-input-checkbox
              label="Super Owner"
              
            />
             <c-input-checkbox
              label="Volunteer"
              
            />
            </div>
            </div>
                 
        <template #footer>
        <CButton @click="largeModal = false" color="danger">Cancel</CButton>
        <CButton @click="largeModal = false" variant="outline" color="info">Save</CButton>
      </template>
    </CModal>
  </div>    
</template>

<script>
import CTableWrapper from './AnnouncmentTable'
import usersData from './DataAnnoucment'

export default {
  name: 'AnnouncmentTables',
  components: { CTableWrapper },
  data () {
    return {
      largeModal: false
    }
  },
  methods: {
   
    shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    },  

    getShuffledUsersData () {
      return this.shuffleArray(usersData.slice(0))
    }
  }
}
</script>
